import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import type { ServiceRequest } from "@curai/js-fhir-tools";
import { useQueryClient } from "@tanstack/react-query";

interface SubmitTriageResponse {
  triagedServiceRequest: ServiceRequest;
}

interface SubmitTriageParams {
  triageAction: (typeof ServiceRequest.TRIAGE_ACTIVITY_ACTION.values)[keyof typeof ServiceRequest.TRIAGE_ACTIVITY_ACTION.values];
  note?: string;
  messageForPatient: string;
}

export const useSubmitTriage = ({
  patientId,
  serviceRequestId,
}: {
  patientId: string;
  serviceRequestId: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<SubmitTriageResponse, SubmitTriageParams>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.MedicalRecords.Labs.SUBMIT_TRIAGE(
        patientId,
        serviceRequestId,
      ),
      mutationFn: (params: SubmitTriageParams) => {
        return axiosInstance.post(
          `/labs/triage/service-request/${serviceRequestId}`,
          params,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.Labs.DEFAULT(patientId),
        });
      },
    },
  });
};
